import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPrivate from "../../services/axios/axiosPrivate";
import { toast } from "react-toastify";

export const deleteExistingEmp = createAsyncThunk(
  "deleteExistingEmp/deleteExistingEmp",
  async (deleteEmpId, { rejectWithValue }) => {
    try {
      const url = `${api.deleteExistingEmp}${deleteEmpId}`;
      console.log("deleteurl", url);
      const response = await axiosPrivate.delete(url);
      if (response.data.success === true) {
        toast.success(
          response.data.data.message || "User deleted successfully",
          {
            className: "toast-success-custom",
          },
        );
      } else {
        toast.error(response.data.data.message || "failed to delete User", {
          className: "toast-error-custom",
        });
      }
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Unable to connect to server",
      );
    }
  },
);

const deleteExistingEmpSlice = createSlice({
  name: "existingEmployees",
  initialState: {
    deleteExistingEmp: {},
    status: "idle",
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builders) => {
    builders
      .addCase(deleteExistingEmp.pending, (state) => {
        state.status = "loading";
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteExistingEmp.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.loading = false;
        state.deleteExistingEmp = action.payload;
      })
      .addCase(deleteExistingEmp.rejected, (state, action) => {
        state.status = "failed";
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default deleteExistingEmpSlice.reducer;
